export const strategiesArray = [
  {
    id: 1,
    title: "5 MIN Momentum Strike",
    description: "A short-term strategy focused on momentum.",
  },
  {
    id: 2,
    title: "LOM Short term",
    description: "Leverages short-term opportunities in LOM.",
  },
  {
    id: 3,
    title: "LOM Long term",
    description: "Optimized for long-term trends in LOM.",
  },
  {
    id: 4,
    title: "10 MIN Momentum Strike",
    description: "Targets momentum within 10-minute windows.",
  },
  {
    id: 5,
    title: "Contraction BO",
    description: "Focuses on breakout opportunities during contractions.",
  },
  {
    id: 6,
    title: "Day H/L Reversal",
    description: "Reversals based on high/low of the day.",
  },
  {
    id: 7,
    title: "2 Day H/L BO",
    description: "Breakouts formed by 2-day high/low levels.",
  },
];
